import {
  FGIcons,
  IconsLarge,
  FGGridContainer,
  FGGridItem,
  FGMediaObject,
  FGMediaObjectFigure,
  FGMediaObjectBody,
  FGButton,
  FGTypography,
  FGStack,
  FGStackItem,
} from '@fg/design-system';

export const FCInquiries = () => {
  const ASIA_CLIENT_MAIL_TO = 'mailto:asiaclient.services@fitchsolutions.com';
  const helpData = [
    {
      img: '/resources/img/newyork.jpg',
      location: 'New York',
      phone: '+1 212 908 0800',
      mailto: 'mailto:usaclientservices@fitchsolutions.com',
    },
    {
      img: '/resources/img/london.jpg',
      location: 'London',
      phone: '+44 (0)20 3530 2400',
      mailto: 'mailto:emeaclientservices@fitchsolutions.com',
    },
    {
      img: '/resources/img/hongkong.jpg',
      location: 'Hong Kong',
      phone: '+852 2263 9999',
      mailto: ASIA_CLIENT_MAIL_TO,
    },
    {
      img: '/resources/img/tokyo.jpg',
      location: 'Tokyo',
      phone: '+81 3 6897 8986',
      mailto: ASIA_CLIENT_MAIL_TO,
    },
    {
      img: '/resources/img/singapore.jpg',
      location: 'Singapore',
      phone: '+65 6796 7231',
      mailto: ASIA_CLIENT_MAIL_TO,
    },
  ];
  return (
    <>
      <div
        style={{
          padding: '32px 32px',
          maxWidth: '1300px',
          margin: '64px auto',
          border: '1px solid rgba(0, 0, 0, 0.12)',
          borderRadius: '3px',
        }}
      >
        <FGGridContainer xxs={1} xs={3} md={5}>
          {helpData.map((item, id) => (
            <FGGridItem key={id}>
              <FGMediaObject alignment="center" classNames="fg-pd--y8">
                <FGMediaObjectFigure>
                  <img src={item.img} alt="" width="115" className="fg-bd--rs-small" />
                </FGMediaObjectFigure>
                <FGMediaObjectBody>
                  <div className="fg-ta--c">
                    <FGTypography tag="h6" style="headline6">
                      {item.location}
                    </FGTypography>
                    <FGTypography tag="p" style="body3-short" className="fg-mg--y2">
                      Client Services
                    </FGTypography>
                    <FGStack alignItems="center" hasDividers>
                      <FGStackItem>
                        <FGTypography tag="p" style="body3-short">
                          {item.phone}
                        </FGTypography>
                      </FGStackItem>
                      <FGStackItem>
                        <FGButton variant="ghost" size="s">
                          <a style={{ color: 'inherit' }} href={item.mailto}>
                            <FGIcons large={IconsLarge.Mail} />
                          </a>
                        </FGButton>
                      </FGStackItem>
                    </FGStack>
                  </div>
                </FGMediaObjectBody>
              </FGMediaObject>
            </FGGridItem>
          ))}
        </FGGridContainer>
      </div>
    </>
  );
};
